"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const BlogPostFragment = (0, graphql_tag_1.default) `
  fragment posts on PostItem {
    id
    title
    subtitle
    slug
    publishedAt
    updatedAt
    categoryId
    categorySlug
    categoryTitle
    image {
      alt
      urls {
        default
        thumbnail
        small
        medium
        large
      }
    }
  }
`;
exports.default = BlogPostFragment;
